<template>
  <div class="offline-page">
    <div class="offline-header sticky-top bg-secondary-theme text-center shadow-sm border-bottom">
      <h1 class="font-weight-bold h6 mx-auto limite offline-header__title">
        LeCard Entregador
      </h1>
    </div>
    <div class="offline-content">
      <div class="container text-center offline-container">
        <div class="mb-4">
          <img src="@/assets/illustrations/semconexao.png" alt="Ilustração de dispositivo sem conexão" class="img-fluid offline-image">
        </div>
        <h3 class="font-weight-bold mt-3 mb-1">Você está offline</h3>
        <p>Acesse a internet para baixar os dados do aplicativo.</p>
        <div class="mt-5 mb-4">
          <a href="/" class="btn btn-primary px-4">Atualizar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Offline'
  }
</script>

<style scoped>
.offline-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.offline-header {
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0));
}

.offline-header__title {
  margin: 16px 0 20px;
  max-width: 65%;
}

.offline-content {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
}

.offline-container {
  padding-top: 24px;
  padding-bottom: 48px;
}

.offline-image {
  width: 100%;
  max-width: 220px;
}

@media (max-width: 767px) {
  .offline-container {
    padding-top: 36px;
    padding-bottom: 64px;
  }
}

.ios_platform .offline-container {
  padding-top: 44px;
  padding-bottom: 72px;
}
</style>
